import { useCallback, useContext, useEffect, useState } from 'react'

// Shopify
import queryShopifyCustomer from '../shopify/queryCustomer'
import queryShopifyLatestCustomer from '../shopify/queryLatestCustomer'

// Context
import { StoreContext } from '../contexts'

// Utils
import loadCustomerAccessToken from '../shopify/loadCustomerAccessToken'

const useCustomer = () => {
  const stores = useContext(StoreContext)
  const client = stores.lastbrandCustomerInfo.client

  const [customer, setCustomer] = useState(null)
  const [initialized, setInitialized] = useState(false);
  const [refreshCustomerData, setRefreshCustomerData] = useState(false)
  const [loading, setLoading] = useState(false)

  const getCustomer = useCallback(async () => {
    setLoading(true)
    const customerAccessToken = await loadCustomerAccessToken(client)
    const { data } = await queryShopifyCustomer(client, {
      customerAccessToken: customerAccessToken.accessToken,
    })
    setCustomer(data.customer)
    setLoading(false)
    setInitialized(true)
  }, [client])

  const getLatestCustomer = async () => {
    const customerAccessToken = await loadCustomerAccessToken(client)
    const { data } = await queryShopifyLatestCustomer(client, {
      customerAccessToken: customerAccessToken.accessToken,
    })
    setCustomer(data.customer)
    setInitialized(true)
  }

  const refreshCustomer = () => {
    getLatestCustomer()
    setRefreshCustomerData(true)
  }

  useEffect(() => {
    async function checkRefreshCustomer() {
      const customerAccessToken = await loadCustomerAccessToken(client)
      if (customerAccessToken && !refreshCustomerData) {
        getCustomer()
      } else if (!refreshCustomerData) {
        setCustomer(null)
        setInitialized(false)
      }
    }

    checkRefreshCustomer()
  }, [getCustomer, refreshCustomerData, client])

  return { customer, refreshCustomer, loading, initialized }
}

export default useCustomer
